import React from 'react';
import ReactDOM from 'react-dom/client';
import '../src/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Put this in App.js or index.js (at the top of the file)

const { fetch: originalFetch } = window;
window.fetch = async (...args) => {
  // 1. Call the original fetch function
  const response = await originalFetch(...args);
  console.log("response", response);

  // 2. Check if the response status is 401 (Unauthorized)
  if (response.status === 401) {
    // 3. Clear the token from storage
    localStorage.removeItem('authToken');
    
    // 4. Redirect user to login (Force a hard refresh to clear state)
    window.location.href = '/login';
    
    // Optional: You can throw an error here to stop further processing in your components
    // throw new Error('Session expired'); 
  }

  // 5. Return the response so your existing code continues to work normally
  return response;
};


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
